import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const MostPopularText = styled(Text)(({ theme }) => ({
    textAlign: "center",
    marginLeft: -1,
    background: theme.colors[theme.colorMode].background_Button_Primary,
    borderBottomLeftRadius: theme.cornerRadius.xSmall,
    borderBottomRightRadius: theme.cornerRadius.xSmall,
}));

export const AmountBoxContainer = styled.button<{ selected: boolean }>(({ theme, selected }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: selected
        ? theme.colors[theme.colorMode].background_Button_Secondary
        : theme.colors[theme.colorMode].text_Button_Primary,
    height: 42,
    width: selected ? 80 : 76,
    borderRadius: theme.cornerRadius.xSmall,
    border: selected
        ? `0.08rem solid ${theme.colors[theme.colorMode].primary}`
        : `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
    margin: 0,
    boxShadow: "0 2px 7px 0 rgba(40, 44, 63, 0.1)",
    "@media (max-width: 380px)": {
        width: selected ? 72 : 68,
    },
    "@media (max-width: 350px)": {
        width: selected ? 64 : 60,
    },
}));

export const AmountBoxTextContainer = styled.div<{ mostPopular: boolean }>(({ mostPopular }) => ({
    display: "flex",
    flexDirection: "column",
    marginTop: 1,
    width: "100%",
    paddingTop: mostPopular ? 10 : 0,
}));
